import api from './apiClient'

export default {
    getPlannedMaintenance: async () => await api.get(`maintenance/planned`),
}